import { Route, Routes } from "react-router-dom";
import { SiteLayout } from "@/components/layout/SiteLayout";
import { HomePage } from "@/pages/HomePage";
import { ContentIndexPage } from "@/pages/ContentIndexPage";
import { ContentDetailPage } from "@/pages/ContentDetailPage";
import { LinksPage } from "@/pages/LinksPage";
import { AdminPage } from "@/pages/AdminPage";
import { NotFoundPage } from "@/pages/NotFoundPage";

export default function App() {
  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route index element={<HomePage />} />
        <Route path="journal" element={<ContentIndexPage kind="journal" />} />
        <Route path="journal/:slug" element={<ContentDetailPage kind="journal" />} />
        <Route path="guides" element={<ContentIndexPage kind="guide" />} />
        <Route path="guides/:slug" element={<ContentDetailPage kind="guide" />} />
        <Route path="scripts" element={<ContentIndexPage kind="script" />} />
        <Route path="scripts/:slug" element={<ContentDetailPage kind="script" />} />
        <Route path="gear" element={<LinksPage variant="gear" />} />
        <Route path="apps" element={<LinksPage variant="apps" />} />
        <Route path="services" element={<LinksPage variant="services" />} />
        <Route path="admin" element={<AdminPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
